import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import { createInitialValues, createFormValidationFn } from 'client/helpers/formikHelpers';

import { PROPERTY_CONDITION_REPORT_MAPPING } from 'common/marketingPartnerListingConstants';

import ListingActions from 'client/actions/Listing';

import SrBox from 'client/components/SrBox';
import SrCard, { SR_CARD_BULLET_COLOR_BLUE } from 'client/components/SrCard/SrCard';
import SrButton, { SR_BUTTON_THEME_ADOBE_GREEN } from 'client/components/SrButton/SrButton';
import SrFormikField, {
  SR_FIELD_THEME_PROPERTY_CONDITION_FORM,
} from 'client/components/SrFormikField';
import useDispatch from 'client/hooks/useDispatch';

function getFormFields() {
  return [
    {
      id: 'propertyConditionOverall',
      title: 'Overall Condition',
      type: 'select',
      properties: {
        enableResetOption: false,
        choices: PROPERTY_CONDITION_REPORT_MAPPING,
      },
      validations: ['required'],
    },
    {
      id: 'propertyConditionUrl',
      title: 'Report URL',
      type: 'short_text',
      validations: ['required', 'url'],
    },
    {
      id: 'propertyConditionDateInspected',
      title: 'Date home was inspected?',
      type: 'date_picker',
      validations: ['required'],
      classnames: `${SR_FIELD_THEME_PROPERTY_CONDITION_FORM} propertyConditionReportDatePicker`,
    },
  ];
}

const SrPartnerListingPagePropertyConditionReportForm = ({
  hideForm,
  marketingListing,
  reloadPartnerListing,
}) => {
  const dispatch = useDispatch();
  const onSubmit = async (formValues) => {
    await dispatch(ListingActions.updatePropertyConditionReport, {
      marketingListingId: marketingListing.id,
      propertyConditionOverall: formValues.propertyConditionOverall,
      propertyConditionUrl: formValues.propertyConditionUrl,
      propertyConditionDateInspected: formValues.propertyConditionDateInspected,
    });

    await reloadPartnerListing();

    hideForm();
  };

  const defaultValues = {
    propertyConditionOverall:
      marketingListing.propertyConditionOverall || PROPERTY_CONDITION_REPORT_MAPPING[0],
    propertyConditionUrl: marketingListing.propertyConditionUrl,
    propertyConditionDateInspected: marketingListing.propertyConditionDateInspected,
  };

  return (
    <SrCard
      header="Condition Report (Admin-Only)"
      color={SR_CARD_BULLET_COLOR_BLUE}
      maxWidth="none"
    >
      <SrBox marginTop="32px">
        <Formik
          validate={(formValues) => {
            const formFields = getFormFields();
            const errors = createFormValidationFn(formFields)(formValues);

            return errors;
          }}
          enableReinitialize
          initialValues={createInitialValues({
            formFields: getFormFields(),
            defaultValues,
          })}
          onSubmit={onSubmit}
          render={(formikBag) => {
            const formFields = getFormFields();

            return (
              <Form autoComplete="off" className="propertyConditionReport">
                <div>
                  {formFields.map((formField) => (
                    <SrFormikField
                      key={formField.id}
                      formField={formField}
                      formikBag={formikBag}
                      className={formField.classnames || SR_FIELD_THEME_PROPERTY_CONDITION_FORM}
                    />
                  ))}
                  <SrBox marginTop="30px">
                    <SrButton
                      type="submit"
                      disabled={!formikBag.isValid || formikBag.isSubmitting}
                      theme={SR_BUTTON_THEME_ADOBE_GREEN}
                    >
                      Save
                    </SrButton>
                  </SrBox>
                </div>
              </Form>
            );
          }}
        />
      </SrBox>
    </SrCard>
  );
};

SrPartnerListingPagePropertyConditionReportForm.propTypes = {
  hideForm: PropTypes.func.isRequired,
  marketingListing: PropTypes.object.isRequired,
  reloadPartnerListing: PropTypes.func.isRequired,
};

SrPartnerListingPagePropertyConditionReportForm.displayName =
  'SrPartnerListingPagePropertyConditionReportForm';

export default SrPartnerListingPagePropertyConditionReportForm;
